import { createLazyComponent } from '@muse-web/router'

export const AsyncAuthModalContainer = createLazyComponent(
    () => import(/* webpackChunkName: 'dialog-auth' */ './AuthModalContainer'),
    'AuthModalContainer',
)
